import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 border-t border-slate-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex flex-col mb-4">
              <h3 className="text-2xl font-bold text-white tracking-tight">EXECUTIVE EV</h3>
              <p className="text-xs text-amber-500 tracking-widest">LUXURY ELECTRIC TRANSPORT</p>
              <a 
                href="https://eev.llc" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-amber-500 hover:text-amber-400 transition-colors mt-1"
              >
                eev.llc
              </a>
            </div>
            <p className="text-gray-300 mb-6">
              Premium all-electric chauffeur service for the discerning traveler.
              Zero emissions, uncompromising luxury.
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center hover:border-amber-500 hover:bg-amber-500/10 transition-all"
              >
                <Facebook className="w-5 h-5 text-gray-300 hover:text-amber-500" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center hover:border-amber-500 hover:bg-amber-500/10 transition-all"
              >
                <Twitter className="w-5 h-5 text-gray-300 hover:text-amber-500" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center hover:border-amber-500 hover:bg-amber-500/10 transition-all"
              >
                <Instagram className="w-5 h-5 text-gray-300 hover:text-amber-500" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center hover:border-amber-500 hover:bg-amber-500/10 transition-all"
              >
                <Linkedin className="w-5 h-5 text-gray-300 hover:text-amber-500" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-300 hover:text-amber-500 transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="#fleet" className="text-gray-300 hover:text-amber-500 transition-colors">
                  Fleet
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-300 hover:text-amber-500 transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-amber-500 transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-300">Airport Transfers</li>
              <li className="text-gray-300">Hourly Service</li>
              <li className="text-gray-300">City-to-City</li>
              <li className="text-gray-300">Corporate Travel</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Executive EV. All rights reserved.
          </p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-amber-500 text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-amber-500 text-sm transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-gray-400 hover:text-amber-500 text-sm transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;